/// Client side global references
type Ref<T> = { current: T | null };

/**
 * Global tenant name reference, set on first page load, from the URL.  There
 * can only be ONE constant tenant per client instance.
 */
export const __GLOBAL_TENANT: Ref<string> = {
  current: null,
};

/**
 * Global session ID attached to events. This is parsed from the graphql
 * response to the WorkQuery (the main first-load query).
 * This is refreshed on every page load and is very temporal.
 */
export const __GLOBAL_SESSION_ID: Ref<string> = {
  current: null,
};

/** Global Phoenix in-memory token */
export const __GLOBAL_AUTH_TOKEN: Ref<string> = {
  current: null,
};

/**
 * Global Assessment context for the rendered Athena application.
 */
export const __GLOBAL_ASSESSMENT_ID: Ref<string> = {
  current: null,
};

/**
 * Global predicate to check for cadmus* tenants.
 */
export function isCadmusTenant(): boolean {
  return (
    __GLOBAL_TENANT.current !== null &&
    __GLOBAL_TENANT.current.startsWith("cadmus")
  );
}

/**
 * Global predicate to check for the unisc tenant.
 */
export function isUniscTenant(): boolean {
  return __GLOBAL_TENANT.current === "unisc";
}

/**
 * Global predicate to check for the acu tenant.
 */
export function disableSubscriptionTenant(): boolean {
  return (
    __GLOBAL_TENANT.current === "acu" || __GLOBAL_TENANT.current === "unisc"
  );
}
